// extracted by mini-css-extract-plugin
export default {"menuBtn":"CommonActionMenu_menuBtn__oqy7G","dropdownMenu":"CommonActionMenu_dropdownMenu__dXSog"};